import React, { useState } from "react";
import Loading from "./Loading";
import { content } from "./content";

const allVideoName = content.map((item) => item.videoName);

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

function App() {
  const [videoSrc, setVideoSrc] = useState("");
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(0);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (allVideoName.includes(file.name)) {
      const vid = content.filter((i) => i.videoName === file.name);
      setId(vid[0].id);
      if (file.type.match("video.*")) {
        // Use the file object directly as the source for the video tag
        setLoading(true);
        setTimeout(() => {
          setVideoSrc(URL.createObjectURL(file));
          setLoading(false);
        }, getRandomArbitrary(5000, 11000));
      } else {
        alert("Please select a video file.");
      }
    } else {
      alert("Please select correct video file.");
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
          <div className="w-full max-w-xs mx-auto mt-5">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="video-upload">
              Select Video
            </label>
            <input
              id="video-upload"
              type="file"
              accept="video/*"
              onChange={handleFileChange}
              className="block w-full px-3 py-2 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            />
          </div>

          <div className="mt-5">
            {videoSrc !== "" && (
              <div className="flex flex-col gap-2 p-12">
                {content[id].isGoal && (
                  <p className="text-3xl text-center text-green-700">GOAL!!</p>
                )}
                {!content[id].isGoal && (
                  <p className="text-3xl text-center text-red-600">
                    NO GOAL...
                  </p>
                )}
                {content[id].resultIsImage ? (
                  <img
                    className="max-w-96 h-auto"
                    src={content[id].resultSrc}
                  />
                ) : (
                  <video
                    id="result"
                    src={content[id].resultSrc}
                    className="max-w-96 h-auto shadow-lg rounded-md"
                    controls></video>
                )}
                <video
                  id="input"
                  src={videoSrc}
                  className="max-w-96 h-auto shadow-lg rounded-md"
                  controls></video>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default App;
